import { render } from "./Validation.vue?vue&type=template&id=1a99ab0a"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/Validation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a99ab0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a99ab0a', __exports__)) {
    api.reload('1a99ab0a', __exports__)
  }
  
  module.hot.accept("./Validation.vue?vue&type=template&id=1a99ab0a", () => {
    api.rerender('1a99ab0a', render)
  })

}


export default __exports__